import React, { useEffect, useState } from "react";
import SectionTitleAndDescription from "./SectionTitleAndDescription";
import { useDispatch, useSelector } from "react-redux";
import KeywordSuggester from "components/AIGenerators/KeyWordSuggester";
import Checkbox from "components/Common/Checkbox/Checkbox";
import { RootState } from "store/store";
import helpicon from "../../images/helpicon.svg";
import SearchFilterDropdown from "components/Common/SearchableDropdown/SearchFilterDropdown";
import {
  addKeyword,
  removeKeyword,
  setExactkeywordsMatch,
  setIncludeAISuggetions,
  resetKeyword,
  setMustHavekeywords,
} from "store/slices/searcSlice";
import MultiSkillSelector from "components/Select/MultiSkillSelector";
import { useDebounce } from "utils";
import { getSkillSearchResult } from "api/search.api";
import { useAppSelector } from "hooks/reduxHooks";
import { Tooltip } from "antd";
import MultiKeywordSelector from "components/Select/MultiKeywordSelector";
import SearchMultiKeywordSelector from "components/Common/SearchableDropdown/SearchableMultiKeywordsSelector";

export interface IKeywordOption {
  value: string;
  label: string;
}

interface AddKeywordsProps {
  jobTitleValue: any;
  isModal?: boolean;
  searchId?: string | null;
}

const AddKeywords: React.FC<AddKeywordsProps> = ({ jobTitleValue, isModal, searchId }) => {
  const dispatch = useDispatch();
  const selectedKeywords = useSelector((state: RootState) => state.search.keywords);
  const selectedProject = useAppSelector((state: any) => state.search?.selectedProject);
  const [inputValue, setInputValue] = useState("");

  const optionsKeywords: IKeywordOption[] = [
    { value: "UX/UI Design", label: "UX/UI Design" },
    { value: "Wireframing", label: "Wireframing" },
    { value: "Prototyping", label: "Prototyping" },
    { value: "Marketing", label: "Marketing" },
    { value: "Management", label: "Management" },
    { value: "Team work", label: "Team work" },
  ];

  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [keywordOptions, setKeywordOptions] = useState<string[]>([]);
  const keywordsExactmatch = useSelector((state: RootState) => state.search.exact_keywords_match);
  const mustHaveKeywords = useSelector((state: RootState) => state.search.must_have_keywords);
  const includeAIsuggetion = useSelector((state: RootState) => state.search.include_ai_suggetions);

  const [keywords, setKeywords] = useState<string[]>([]); // State to track added keywords

  // const onChange = (values: string[]) => {
  //   console.log("Values : ", values);
  //   console.log("Keywords : ", keywords);
  //   const uniqueKeywords = values.filter((value) => !selectedKeywords.includes(value)); // Filter out duplicates
  //   console.log("uniqueKeywords : ", uniqueKeywords);
  //   if (uniqueKeywords.length > 0) {
  //     setKeywords((prev) => [...prev, ...uniqueKeywords]); // Update state with new keywords
  //     handleAdd(uniqueKeywords[0]); // Send only new and unique keywords
  //   }
  // };

  const onChange = (values: string[]) => {
    const uniqueKeywords: any = values.filter((value: any) => !selectedKeywords.includes(value.value));
    if (uniqueKeywords.length > 0) {
      setKeywords((prev) => [...prev, uniqueKeywords[0].value]);
      handleAdd(uniqueKeywords[0].value);
    }
  };

  const handleBlur = (value: string) => {
    if (inputValue.length > 0) {
      dispatch(addKeyword(inputValue));
    }
  };

  const handleDeselect = (value: string | null) => {
    console.log("Handle Deselect : ", value);
    if (value) {
      dispatch(removeKeyword(value));
    }
  };

  const handleAdd = (skill: string) => {
    try {
      dispatch(addKeyword(skill));
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const handleExactMatchChange = () => {
    dispatch(setExactkeywordsMatch(!keywordsExactmatch)); // Dispatch action to update Redux store
  };

  const handleMustHaveChange = () => {
    dispatch(setMustHavekeywords(!mustHaveKeywords)); // Dispatch action to update Redux store
  };

  const handleIncludeAISuggetionsChange = () => {
    dispatch(setIncludeAISuggetions(!includeAIsuggetion)); // Dispatch action to update Redux store
  };

  const handleSearchSkill = async (skill: string) => {
    const res = await getSkillSearchResult(skill).then((data: any) => {
      const skillData = data?.data?.autocomplete?.result?.map((label: any) => ({
        label: label,
        value: label,
      }));
      const customSkill = [
        {
          value: skill,
          label: skill,
        },
      ];
      setKeywordOptions(skillData ?? customSkill);
    });
  };

  const debouncedSearchSkill = useDebounce((skill: string) => {
    handleSearchSkill(skill);
  }, 500);

  const handleInputChange = (inputValue: string) => {
    if (inputValue) {
      debouncedSearchSkill(inputValue);
    }
  };

  useEffect(() => {
    if (selectedProject && !isModal && !searchId) {
      dispatch(resetKeyword());
      const keyWords = selectedProject.keywords || [];
      const slicedKeyWords = keyWords.length < 10 ? keyWords : keyWords.slice(0, 9);
      setKeywords(slicedKeyWords);
      slicedKeyWords.map((item: string, index: number) => {
        handleAdd(item);
      });
    }
  }, [selectedProject]);

  const handleClearAll = () => {
    dispatch(resetKeyword());
    setKeywords([]);
  };

  // useEffect(() => {
  //   console.log("Selected jobTitleValue: ", jobTitleValue);
  //   console.log("selectedKeywords", selectedKeywords);
  // }, [jobTitleValue, selectedKeywords]);

  return (
    <>
      <div className="w-1/4">
        <SectionTitleAndDescription
          title="Add Keywords"
          isRequiredSection={false}
          isHelpInfoReq={false}
          tooltipText="This is a Keywords"
          description="Provide the keywords you wish to use for the search, or select from the list of Recommended."
        />
      </div>
      <div className="w-3/4  grid  items-center">
        <KeywordSuggester
          jobTitles={selectedKeywords.length > 0 ? selectedKeywords : jobTitleValue}
          isSectionTitleRequired={true}
          sectionTitle="Recommended"
          handleAdd={handleAdd}
          selectedValues={selectedKeywords}
          onClearAll={handleClearAll}
        ></KeywordSuggester>
        <div>
          <MultiKeywordSelector
            placeholder="eg: React.js"
            defaultValue={selectedKeywords}
            rootClassName={"border-primary"}
            handleDeselect={handleDeselect}
            onChange={onChange}
          />
          {/* <SearchFilterDropdown
            title="keywords"
            mode="multiple"
            placeholder="Enter and select keywords"
            options={keywordOptions}
            maxSelect={100}
            onChange={onChange}
            defaultValue={selectedKeywords}
            handleDeselect={handleDeselect}
            onBlur={handleBlur}
            onInputChange={handleInputChange}
          /> */}
        </div>
        <div className="flex gap-8 justify-start items-center mt-6 flex-wrap">
          {/* <div className="checkbox-wrapper flex flex-wrap justify-center items-center gap-2">
            <Checkbox
              inputName={"ExactKeywordMatch"}
              inputValue="Exact Match"
              inputId={"ExactKeywordMatch"}
              labelFor={"ExactKeywordMatch"}
              labelTitle={"Exact Match"}
              checked={keywordsExactmatch}
              onChange={handleExactMatchChange}
            />
          </div> */}
          <div className="checkbox-wrapper flex flex-wrap justify-center items-center gap-2">
            <Checkbox
              inputName={"MustHaveKeyword"}
              inputValue="Must have"
              inputId={"MustHaveKeyword"}
              labelFor={"MustHaveKeyword"}
              labelTitle={"Must have"}
              checked={mustHaveKeywords}
              onChange={handleMustHaveChange}
            />
            <Checkbox
              inputName={"AIsuggestions"}
              inputValue="AI suggestions"
              inputId={"AIsuggestions"}
              labelFor={"AIsuggestions"}
              labelTitle={"Include AI suggestions"}
              checked={includeAIsuggetion}
              onChange={handleIncludeAISuggetionsChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddKeywords;
